<template>
    <div class="optpl-no-results">
        <figure><img :src="imgUrl('empty-folder.svg')" alt="No items found" class="opui-my-4" width="150" height="150" loading="lazy" /></figure>
        <h4 v-if="title">{{ title }}</h4>
        <p v-if="text">
            {{ text }}
            <a href="#" @click.prevent="this.$events.emit('resetFilters')">Clear search</a>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, default: 'No items found' },
        text: { type: String, default: 'Sorry it looks like your search returned no results.' },
        reset: { type: Boolean, default: false }
    },
}
</script>

<style scoped>
.optpl-no-results {
    text-align: center;
    padding: 20px;
    color: #666;
    font-size: 16px;
    line-height: 1.5;
    margin: 0 auto;
}
.optpl-no-results h4 {
    font-size: 20px !important;
    margin-bottom: 15px !important;
    color: #000 !important;
}
</style>
